module.exports = __webpack_public_path__ + "static/img/icon-SHA.5d1591b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-SHA.svg
// module id = clUx
// module chunks = 0